import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import ServicesGrid from "@/components/ServicesGrid";
import CommunitySpotlight from "@/components/CommunitySpotlight";
import BeforeAfterGallery from "@/components/BeforeAfterGallery";
import FaqSection from "@/components/FaqSection";
import ContactHours from "@/components/ContactHours";
import Footer from "@/components/Footer";

const Page = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="app-shell" className="min-h-screen bg-[#0A0B0E] text-[#F8F9FA]">
      <Header />
      <main>
        <Hero />
        <BrandMarquee />
        <ServicesGrid />
        <CommunitySpotlight />
        <BeforeAfterGallery />
        <FaqSection />
        <ContactHours />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Page />
    </LanguageProvider>
  );
}

export default App;
